    <template>
  <div>
    <a-row style="margin: 0 -12px">
      <a-col
        style="padding: 0 12px"
        :xl="6"
        :lg="24"
        :md="24"
        :sm="24"
        :xs="24"
      >
        <a-card title="组织机构" :bordered="false">
          <a-input-search
            style="margin-bottom: 8px"
            placeholder="请输入名称"
            v-model="organizationsParams.name"
            @change="fetchOrganizationData"
          />
          <a-tree
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            :tree-data="gData"
            @expand="onExpand"
            @select="onSelect"
            :loading="loadingData"
          >
            <template #title="{ key: treeKey, title, dataRef }">
              <a-dropdown :trigger="['contextmenu']">
                <div style="display: grid; grid-template-row: 4fr 1fr">
                  <span class="text-overflow">{{ title }}</span>
                  <a-dropdown
                    :trigger="['click']"
                    v-if="treeKey != 'xy' && treeKey != 'bm'"
                  >
                    <a
                      class="ant-dropdown-link"
                      @click.stop.prevent
                      style="position: absolute; right: 30px"
                    >
                      <a-icon type="more" />
                    </a>
                    <template #overlay>
                      <a-menu
                        @click="
                          ({ key: menuKey }) =>
                            onContextMenuClick(treeKey, menuKey, title, dataRef)
                        "
                      >
                        <a-menu-item key="modfiyName">修改名称</a-menu-item>
                        <a-menu-item key="del">
                          <a-popconfirm
                            title="确认删除吗?"
                            ok-text="是"
                            cancel-text="否"
                            @confirm="deleteOrganization(treeKey)"
                          >
                            <a> 删除</a>
                          </a-popconfirm>
                        </a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                  <a
                    class="ant-dropdown-link"
                    v-else
                    @click.stop="
                      onContextMenuClick(treeKey, 'createSub', title, dataRef)
                    "
                    style="position: absolute; right: 33px; color: #444444"
                  >
                    <a-icon type="plus" />
                  </a>
                </div>
              </a-dropdown>
            </template>
          </a-tree>
        </a-card>
      </a-col>
      <a-col
        style="padding: 0 12px"
        :xl="18"
        :lg="24"
        :md="24"
        :sm="24"
        :xs="24"
      >
        <a-card
          :bordered="false"
          :title="
            selectedTitle
              ? selectedTitle + '(' + pagination.total + '人)'
              : '...'
          "
          :loading="loadingData || loading"
        >
          <div class="btn-group">
            <a-button
              :disabled="!selectedTitle"
              type="primary"
              @click="oneAddUser"
              >添加用户</a-button
            >
            <a-button :disabled="!selectedTitle" @click="openUploadModal"
              >批量导入</a-button
            >
          </div>

          <a-table
            :columns="columns"
            :dataSource="data"
            :loading="loading"
            :pagination="pagination"
            :rowKey="(row) => row.id"
          >
            <span slot="status" slot-scope="text">
              {{ text == 0 ? "正常" : "禁用" }}
            </span>
            <span slot="action" slot-scope="row">
              <a-button type="link" size="small" @click="onEditUser(row)"
                >编辑</a-button
              >
              <a-button type="link" size="small" @click="onEditUserOrg(row)"
                >移动</a-button
              >
              <a-button
                type="link"
                size="small"
                @click="updateStatus(row.id, row.status == 0 ? '1' : '0')"
              >
                {{ row.status == 0 ? "禁用" : "启用" }}</a-button
              >
              <a-popconfirm
                title="确认删除吗?"
                ok-text="是"
                cancel-text="否"
                @confirm="del(row.id)"
              >
                <a-button type="link" size="small">删除</a-button>
              </a-popconfirm>
            </span>
          </a-table>
        </a-card>
      </a-col>
    </a-row>
    <a-modal
      v-model="createModal"
      :title="currentOrgFrom.id ? '编辑' : '新建'"
      @ok="submit"
    >
      <a-form-model ref="ruleForm" :model="currentOrgFrom" :rules="rules">
        <a-form-model-item
          label="编码"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="orgCode"
        >
          <a-input v-model="currentOrgFrom.orgCode" placeholder="请输入编码" />
        </a-form-model-item>
        <a-form-model-item
          label="名称"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="orgName"
        >
          <a-input v-model="currentOrgFrom.orgName" placeholder="请输入名称" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      v-model="addUserModal"
      :title="currentUserFrom.id ? '编辑用户' : '添加用户'"
      @ok="submitUserFrom"
    >
      <a-form-model
        ref="addUserRuleForm"
        :model="currentUserFrom"
        :rules="userFromRules"
      >
        <a-form-model-item
          label="用户名"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="userAccount"
        >
          <a-input
            placeholder="请输入用户名"
            v-model="currentUserFrom.userAccount"
          />
        </a-form-model-item>
        <a-form-model-item
          label="学工号"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="userCode"
        >
          <a-input
            placeholder="请输入学工号"
            v-model="currentUserFrom.userCode"
          />
        </a-form-model-item>
        <a-form-model-item
          label="姓名"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="userName"
        >
          <a-input
            placeholder="请输入姓名"
            v-model="currentUserFrom.userName"
          />
        </a-form-model-item>
        <a-form-model-item
          label="手机号"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="userMobile"
        >
          <a-input
            placeholder="请输入手机号"
            type="number"
            v-model="currentUserFrom.userMobile"
          />
        </a-form-model-item>
        <!-- <a-form-model-item
          label="密码"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="userPassword"
        >
          <a-input
            type="password"
            placeholder="请输入密码"
            v-model="currentUserFrom.userPassword"
          />
        </a-form-model-item>
        <a-form-item
          label="确认密码"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          :validate-status="
            !currentUserFrom.userPassword2 ||
            currentUserFrom.userPassword2 == currentUserFrom.userPassword
              ? 'success'
              : 'error'
          "
          :help="
            !currentUserFrom.userPassword2 ||
            currentUserFrom.userPassword2 == currentUserFrom.userPassword
              ? ''
              : '两次密码不一致'
          "
        >
          <a-input
            type="password"
            placeholder="请输入密码"
            v-model="currentUserFrom.userPassword2"
          />
        </a-form-item> -->
        <a-form-model-item
          v-if="!currentUserFrom.id"
          label="所属"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="orgId"
        >
          <a-select
            v-model="addUserOneSelectVal"
            style="width: 120px"
            :allowClear="true"
            placeholder="请选择"
            @change="addUserOneSelectChange"
          >
            <a-select-option
              v-for="item in gData"
              :item="item"
              :value="item.key"
              :key="item.key"
              >{{ item.title }}</a-select-option
            >
          </a-select>
          <a-select
            v-model="currentUserFrom.orgId"
            style="width: 120px"
            :allowClear="true"
            placeholder="请选择"
            @change="addUser2SelectChange"
          >
            <a-select-option
              v-for="i in addUser2SelectData"
              :value="i.key"
              :key="i.key"
              >{{ i.title }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal v-model="changeUserOrgModal" title="移动组织" @ok="moveUser">
      <a-form-model
        ref="userMoveForm"
        :model="currentUserFrom"
        :rules="userMoveFromRules"
      >
        <a-form-model-item
          label="所属"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 17 }"
          prop="orgId"
        >
          <a-select
            v-model="addUserOneSelectVal"
            style="width: 120px"
            :allowClear="true"
            placeholder="请选择"
            @change="addUserOneSelectChange"
          >
            <a-select-option
              v-for="item in gData"
              :item="item"
              :value="item.key"
              :key="item.key"
              >{{ item.title }}</a-select-option
            >
          </a-select>
          <a-select
            v-model="currentUserFrom.orgId"
            style="width: 120px"
            :allowClear="true"
            placeholder="请选择"
            @change="addUser2SelectChange"
          >
            <a-select-option
              v-for="i in addUser2SelectData"
              :value="i.key"
              :key="i.key"
              >{{ i.title }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal v-model="uploadModal" title="上传" @ok="importUsers">
      <ol>
        <li>
          <p>
            下载模板，并按照模板中的使用说明填写信息，<span style="color: red">
              请勿更改表结构（如删除某行）</span
            >
          </p>
          <p><a @click="downloadTemplateFile">下载《组织结构导入模板》</a></p>
        </li>
        <li>
          <p>请选择填写完成的excel 文档</p>
          <a-form-model
            ref="uploadExcelRuleForm"
            :model="fileInfo"
            :rules="uploadExcelRules"
          >
            <a-form-model-item
              :labelCol="{ span: 0 }"
              :wrapperCol="{ span: 24 }"
              prop="fileName"
            >
              <c-upload
                name="file"
                :multiple="false"
                :action="uploadFileUri"
                acceptType="excel"
                @change="handleChange"
              >
                <div v-if="fileInfo.fileName">
                  <a-icon type="file-excel" />
                  <a v-text="fileInfo.fileName"></a>
                </div>
                <a-button v-else>
                  <a-icon :type="loadingFile ? 'loading' : 'plus'" />选择文件
                </a-button>
              </c-upload>
            </a-form-model-item>
          </a-form-model>
          <p>请上传格式为xls或xlsx的文件，最大支持30M</p>
        </li>
      </ol>
    </a-modal>
  </div>
</template>

<script>
//eslint-disable-next-line
import {
  queryAllOrganizations,
  saveOrganization,
  updateOrganization,
  delOrganization,
} from "@/services/organization";
import {
  getUsersByTypeName,
  addOneUser,
  editOneUser,
  delUser,
  updateUserStatus,
  downloadUserExcel,
  importUsers,
} from "@/services/user";
import uploadFileUri from "@/services/uploadFileUri";

const rules = {
  orgCode: [{ required: true, message: "请输入编码", trigger: "change" }],
  orgName: [{ required: true, message: "请输入名称", trigger: "change" }],
};
const uploadExcelRules = {
  fileName: [{ required: true, message: "请选择文件", trigger: "change" }],
};
const userFromRules = {
  userAccount: [{ required: true, message: "请输入用户名", trigger: "change" }],
  userCode: [{ required: true, message: "请输入学工号", trigger: "change" }],
  userName: [{ required: true, message: "请输入姓名", trigger: "change" }],
  userMobile: [{ required: true, message: "请输入手机号", trigger: "change" }],
  // userPassword: [{ required: true, message: "请输入密码", trigger: "change" }],
  orgId: [{ required: true, message: "请选择所属组织", trigger: "change" }],
};
const userMoveFromRules = {
  orgId: [{ required: true, message: "请选择所属组织", trigger: "change" }],
};

const gData = [];

const dataList = [];
const generateList = (data) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i];
    const key = node.key;
    dataList.push({ key, title: key });
    if (node.children) {
      generateList(node.children);
    }
  }
};
generateList(gData);

const getParentKey = (key, tree) => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};

const columns = [
  {
    title: "账号名称",
    dataIndex: "userAccount",
  },
  {
    title: "学工号",
    dataIndex: "userCode",
  },
  {
    title: "姓名",
    dataIndex: "userName",
  },
  {
    title: "手机号",
    dataIndex: "userMobile",
  },
  {
    title: "部门/学院",
    dataIndex: "orgName",
  },
  {
    title: "权限组",
    dataIndex: "roleName",
  },
  {
    title: "状态",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

const data = [];

export default {
  name: "Organization",
  data() {
    return {
      rules,
      uploadExcelRules,
      userFromRules,
      userMoveFromRules,
      addUserOneSelectVal: undefined,
      addUser2SelectData: [],
      expandedKeys: [],
      searchValue: "",
      autoExpandParent: true,
      gData,
      selectedKey: undefined,
      selectedTitle: undefined,
      createModal: false,
      modifyNameModal: false,
      addUserModal: false,
      changeUserOrgModal: false,
      uploadModal: false,
      loading: false,
      loadingData: false,
      columns,
      data,
      treeExpandedKeys: [],
      fileInfo: { fileName: undefined },
      uploadFileUri,
      params: {
        orgId: undefined,
        name: "",
        page: 1,
        limit: 10,
      },
      pagination: {
        pageSize: 10,
        showTotal: (total) => `共${total}条`,
        current: 1,
        total: 0,
        onChange: (current) => this.onPageChange(current),
      },
      organizationsParams: {
        type: "部门",
        status: 0,
        name: "",
      },
      currentOrgFrom: {
        orgName: "",
        type: "",
        remark: "",
      },
      currentUserFrom: {
        userAccount: undefined,
        userName: undefined,
        userPassword: undefined,
        userMobile: undefined,
        orgName: undefined,
        userSex: undefined,
        userBirth: undefined,
        remark: undefined,
        orgId: undefined,
      },
      loadingFile: false,
    };
  },
  watch: {
    //监听modal关闭清空表单
    createModal(val) {
      if (!val) {
        this.currentOrgFrom.orgCode = "";
        this.currentOrgFrom.orgName = "";
      }
    },
  },
  async mounted() {
    await this.fetchOrganizationData();
    console.log(this.gData);
  },
  methods: {
    quitModal() {
      // this.fileInfo = {};
      // this.fileList = [];
    },
    handleChange(info) {
      console.log(info);
      if (info.file.status !== "uploading") {
        this.loadingFile = true;
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.loadingFile = false;
        this.fileInfo.filePath = info.file.response.data.filePath;
        this.fileInfo.fileName = info.file.name;
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} 文件上传失败.`);
      }
    },
    addUserOneSelectChange(e, i) {
      this.addUser2SelectData = i.data.attrs.item.children;
      console.info("addUserOneSelectChange", e, this.addUser2SelectData);
    },
    addUser2SelectChange(e, i) {
      console.info("addUser2SelectChange", e, i);
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onSelect(selectedKeys, info) {
      // let parentKey = info.selectedNodes[0].context.$parent.expandedKeys[0];
      // console.log("selected", selectedKeys, info, parentKey);
      this.selectedKey = selectedKeys[0];
      this.selectedTitle = info.node.dataRef.title;
      this.params.orgId = selectedKeys[0];
      this.search();
    },
    onChange(e) {
      const value = e.target.value;
      const expandedKeys = dataList
        .map((item) => {
          if (item.title.indexOf(value) > -1) {
            return getParentKey(item.key, gData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true,
      });
    },
    onContextMenuClick(id, key, title, item) {
      console.log("onContextMenuClick", id, key, title, item);
      if (key === "createSub") {
        this.currentOrgFrom.type = title;
        this.createModal = true;
      } else if (key === "modfiyName") {
        this.currentOrgFrom = Object.assign({}, item);
        this.createModal = true;
      }
    },
    submit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (this.currentOrgFrom.id) {
            await updateOrganization(this.currentOrgFrom);
          } else {
            await saveOrganization(this.currentOrgFrom);
          }
          this.$message.success("操作成功");
          this.createModal = false;
          this.fetchOrganizationData();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleOk() {
      if (this.addUserModal) {
        this.addOneUser();
      }
    },
    loadData() {
      this.loading = true;
      getUsersByTypeName(this.params).then((res) => {
        this.data = res.records;
        this.loading = false;
        this.pagination.current = res.current;
        this.pagination.total = res.total;
      });
    },
    onPageChange(page) {
      this.params.page = page;
      this.loadData();
    },
    search() {
      this.onPageChange(1);
    },
    async fetchOrganizationData() {
      this.loadingData = true;
      //获取组织结构数据
      this.organizationsParams.type = "部门";
      const d = await queryAllOrganizations(this.organizationsParams);
      this.organizationsParams.type = "学院";
      const xueyuan = await queryAllOrganizations(this.organizationsParams);
      this.gData = [];
      this.gData.push({
        key: "xy",
        title: "学院",
        scopedSlots: { title: "title" },
        children: xueyuan.map(function (item) {
          return {
            key: item.id,
            title: item.orgName,
            scopedSlots: { title: "title" },
            dataRef: item,
          };
        }),
      });
      this.gData.push({
        key: "bm",
        title: "部门",
        scopedSlots: { title: "title" },
        children: d.map(function (item) {
          return {
            key: item.id,
            title: item.orgName,
            scopedSlots: { title: "title" },
            dataRef: item,
          };
        }),
      });
      this.loadingData = false;
    },
    async deleteOrganization(id) {
      //删除组织结构
      await delOrganization({ id });
      this.$message.success("操作成功");
      this.fetchOrganizationData();
    },
    async moveUser() {
      this.$refs.userMoveForm.validate(async (valid) => {
        if (valid) {
          await editOneUser(
            Object.assign({}, this.currentUserFrom, {
              orgId: this.currentUserFrom.orgId
                ? this.currentUserFrom.orgId
                : this.currentUserFrom.oId,
            })
          );
          this.$message.success("操作成功");
          this.changeUserOrgModal = false;
          this.search();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async submitUserFrom() {
      this.$refs.addUserRuleForm.validate(async (valid) => {
        if (valid) {
          if (this.currentUserFrom.id) {
            await editOneUser(
              Object.assign({}, this.currentUserFrom, {
                orgId: this.currentUserFrom.orgId
                  ? this.currentUserFrom.orgId
                  : this.currentUserFrom.oId,
              })
            );
          } else {
            await addOneUser(this.currentUserFrom);
          }
          this.$message.success("操作成功");
          this.addUserModal = false;
          this.search();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async del(id) {
      await delUser({ id });
      this.$message.success("操作成功");
      this.search();
    },
    async updateStatus(id, status) {
      await updateUserStatus({ id, status });
      this.$message.success("操作成功");
      this.search();
    },
    oneAddUser() {
      this.addUserOneSelectVal = undefined;
      this.currentUserFrom = {};
      this.addUserModal = true;
    },
    onEditUser(row) {
      this.gData.forEach((item) => {
        item.children.forEach((item2) => {
          if (item2.dataRef.id === row.orgId) {
            this.addUserOneSelectVal = item.key;
            this.addUser2SelectData = item.children;
          }
        });
      });
      this.currentUserFrom = Object.assign({}, row);
      this.addUserModal = true;
    },
    onEditUserOrg(row) {
      this.gData.forEach((item) => {
        item.children.forEach((item2) => {
          if (item2.dataRef.id === row.orgId) {
            this.addUserOneSelectVal = item.key;
            this.addUser2SelectData = item.children;
          }
        });
      });
      this.currentUserFrom = Object.assign({}, row);
      this.changeUserOrgModal = true;
    },
    openUploadModal() {
      this.uploadModal = true;
      this.fileInfo.fileName = undefined;
    },
    async importUsers() {
      const msgContet = await importUsers({ filepath: this.fileInfo.filePath });
      if (msgContet.msg) return this.$message.error(msgContet.msg);
      this.uploadModal = false;
      this.fileInfo.filePath = undefined;
      this.fileInfo.fileName = undefined;
      this.$message.success("操作成功");
      this.search();
    },
    downloadTemplateFile() {
      downloadUserExcel();
    },
  },
};
</script>
<style>
.ant-tree li .ant-tree-node-content-wrapper {
  width: 90%;
}
</style>
